import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, submit } from "redux-form";
import { BaseComponent } from "BaseComponent";
import _ from "lodash";
import { fetchBranding, updateSplashData } from "BrandingAction";
import { updateUnsavedChanges } from "DashboardMenuAction";
import {
  IMAGE_PATH,
  BASE_IMAGES_URL,
  screenHeightLeftFromTop,
} from "Constants";
import ImageCropper from "ImageCropper";
import Loader from "Loader";
import LocaleStrings from "Languages";

class SplashScreen extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchBranding(this.props.session);
  }

  submit = () => {
    this.props.dispatch(submit("Splash-Form"));
    this.props.handleSubmit();
  };

  onImageSave = (item, image) => {
    let { screensList } = this.props;

    // console.log("item :- ", item);
    // console.log("image :- ", image);

    let list = screensList;
    let index = list.findIndex((x) => x.key === item.key);
    // console.log("index :- ", index);

    list[index].data = image;

    this.props.change(`${item.key}`, image);
    this.props.updateSplashData(list);
    this.props.updateUnsavedChanges(true);
  };

  onImageChange = (imageAvailable) => {};

  renderList = (screen) => {
    let { session, screensList } = this.props;
    let screenData = _.filter(screensList, (o) => {
      return o.section === screen;
    });

    return _.map(screenData, (item, index) => {
      var Obj = {
        "#width": item.requiredSize.width,
        "#height": item.requiredSize.height,
      };

      var imagePreview = "";
      if (item.data) {
        var file = item.data;
        var n = file.search(";base64,");
        imagePreview = `${BASE_IMAGES_URL}/${item.data}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
        if (n > 0) {
          imagePreview = file;
        }
      }

      return (
        <div>
          <ImageCropper
            displaySize={{
              width: item.displaySize.width,
              height: item.displaySize.height,
            }} // For image display style
            requiredSize={{
              width: item.requiredSize.width,
              height: item.requiredSize.height,
            }} // For image size required validation
            cropperSize={{
              width: item.cropperSize.width,
              height: item.cropperSize.height,
            }} // Cropper display size. Note its add 50px for padding
            border={10}
            onImageSave={this.onImageSave.bind(this, item)}
            onImageChange={this.onImageChange}
            imagepath={imagePreview}
            imageType="jpg"
            className="splash-drop-zone-area-custom-image"
            insideImage={`${IMAGE_PATH}dummy-image-fill@3x.png`}
            insideImageStyle={{
              width: 36,
              height: 36,
            }}
            insideText={LocaleStrings.upload_image_text}
          />
          <div className="custom-text2-secondary-normal mt-2">
            {LocaleStrings.upload_image_size_text.replace(
              /#width|#height/gi,
              (matched) => {
                return Obj[matched];
              }
            )}
          </div>
          <Field
            name={`${item.key}`}
            type="text"
            component={this.renderHiddenFieldText}
          />
        </div>
      );
    });
  };

  render() {
    let { deviceSize, handleSubmit, submit, screensList } = this.props;

    return (
      <div
        className="panel-body scrollable-content"
        style={{ height: deviceSize.height - screenHeightLeftFromTop }}
      >
        {screensList.length > 0 ? (
          <form onSubmit={handleSubmit(submit)} encType="multipart/form-data">
            {/* Ios splash screen */}
            <div className="splash-screen-container">
              <div className="splash-screen-device-header vertical-align-center gap-2">
                <img
                  alt=""
                  src={`${IMAGE_PATH}branding-icons/ios-splash-logo.svg`}
                />
                <div>
                  <div className="custom-text3-primary-medium">
                    {LocaleStrings.branding_splash_ios_title}
                  </div>
                  <div className="custom-text2-secondary-normal">
                    {LocaleStrings.branding_splash_ios_subtitle}
                  </div>
                </div>
              </div>

              <div className="vertical-align-end gap-3 mt-4">
                {this.renderList("ios")}
              </div>
            </div>

            {/* Android splash screen */}
            <div className="splash-screen-container mt-3">
              <div className="splash-screen-device-header vertical-align-center gap-2">
                <img
                  alt=""
                  src={`${IMAGE_PATH}branding-icons/android-splash-logo.svg`}
                />
                <div>
                  <div className="custom-text3-primary-medium">
                    {LocaleStrings.branding_splash_android_title}
                  </div>
                  <div className="custom-text2-secondary-normal">
                    {LocaleStrings.branding_splash_android_subtitle}
                  </div>
                </div>
              </div>

              <div className="vertical-align-end gap-3 mt-4">
                {this.renderList("android")}
              </div>
            </div>
          </form>
        ) : (
          <div className="loader-container">
            <Loader />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log(state.splashScreenData);

  return {
    session: state.session,
    deviceSize: state.deviceSize,
    screensList: state.splashScreenData,
  };
}

function validate() {}

function onFormSubmit(values, dispatch, props) {
  values.source = "splash";
  values.splashdataarray = props.screensList;
  // console.log("values :- ", values);

  props.submitBrandingDataHandler(values);
}

export default connect(
  mapStateToProps,
  {
    fetchBranding,
    updateSplashData,
    updateUnsavedChanges,
  },
  null,
  { forwardRef: true }
)(
  reduxForm({
    validate,
    form: "Splash-Form",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(SplashScreen)
);
